import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_AdultAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_AdultAssessment' className='file-pdf-document'>
            <div className='file-template'>



                <h3>ADULT BEHAVIORAL HEALTH ASSESSMENT</h3>
                <h4>
                    A. DEMOGRAPHIC INFORMATION (COMPLETE ALL INFORMATION)
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Assessor Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtAssessorName" name="txtAssessorName" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="radio" id="rbInitialAssessment_Yes" name="rbInitialAssessment" className='add-only' value="1" /> Initial Assessment &nbsp;
                    <input type="radio" id="rbInitialAssessment_No" name="rbInitialAssessment" className='add-only' value="0" /> Re-Assessment
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Individual Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Parent/Guardian:</span></td>
                        <td className='w-250'><span className='eleHeader'>Primary Contact #</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtIndividualName" name="txtIndividualName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtParent" name="txtParent" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrimaryContact" name="txtPrimaryContact" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Email Address</span></td>
                        <td className='w-250'><span className='eleHeader'>Physical Address:</span></td>
                        <td className='w-250'><span className='eleHeader'>City:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtEmailAddress" name="txtEmailAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPhysicalAddress" name="txtPhysicalAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>State:</span></td>
                        <td className='w-250'><span className='eleHeader'>Zip code</span></td>
                        <td className='w-250'><span className='eleHeader'>Individual DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtState" name="txtState" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtZipCode" name="txtZipCode" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtIndividualDob" name="txtIndividualDob" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Age</span></td>
                        <td className='w-250'><span className='eleHeader'>Race/Ethnicity</span></td>
                        <td className='w-250'><span className='eleHeader'>Gender</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAge" name="txtAge" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRaceEthnicity" name="txtRaceEthnicity" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSexAtBirth_Yes" name="rbSexAtBirth" className='add-only' value="1" />Male
                            <input type="radio" id="rbSexAtBirth_No" name="rbSexAtBirth" className='add-only' value="0" />Female
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Emergency Contact Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Contact Telephone</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtEmergencyContact" name="txtEmergencyContact" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship" name="txtRelationship" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactTelephone" name="txtContactTelephone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Referral Source:</span>
                    <textarea id="txtReferralSource" name="txtReferralSource" className='add-only'></textarea>
                </p>
                <p>
                    <strong>INSURANCE INFORMATION</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insurance Type</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_1" name="cbInsuranceType_1" className='add-only' value="InsuranceType_1" />Medicaid Standard:
                            <input type="text" id="txtMedicaid1" name="txtMedicaid1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_2" name="cbInsuranceType_2" className='add-only' value="InsuranceType_2" />Peachstate:
                            <input type="text" id="txtMedicaid2" name="txtMedicaid2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_3" name="cbInsuranceType_3" className='add-only' value="InsuranceType_3" />Amerigroup:
                            <input type="text" id="txtMedicaid3" name="txtMedicaid3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_4" name="cbInsuranceType_4" className='add-only' value="InsuranceType_4" />Caresource:
                            <input type="text" id="txtMedicaid4" name="txtMedicaid4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>B. INDIVIDUAL PRESENTATION & PRESENTING PROBLEM</h3>
                <p>
                    <span className='eleHeader'>Location of assessment?</span>
                    <textarea id="txtLocationAssessment" name="txtLocationAssessment" className='add-only'></textarea>
                    <span className='eleHeader'>Who was present during assessment?</span>
                    <textarea id="txtPresentAssessment" name="txtPresentAssessment" className='add-only'></textarea>
                </p>
                <h3>C. BRIEF MENTAL STATUS EXAM<span className='small'>(Check all that apply)</span></h3>
                <p>
                    <span className='eleHeader'>General Appearance</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_1" name="cbGeneralAppearance_1" className='add-only' value="GeneralAppearance_1" />Overweight
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_2" name="cbGeneralAppearance_2" className='add-only' value="GeneralAppearance_2" />Frail
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_3" name="cbGeneralAppearance_3" className='add-only' value="GeneralAppearance_3" />Lean
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_4" name="cbGeneralAppearance_4" className='add-only' value="GeneralAppearance_4" />Muscular
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_5" name="cbGeneralAppearance_5" className='add-only' value="GeneralAppearance_5" />Neat
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Behavior</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_1" name="cbBehavior_1" className='add-only' value="Behavior_1" />Older than age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_2" name="cbBehavior_2" className='add-only' value="Behavior_2" />Younger than age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_3" name="cbBehavior_3" className='add-only' value="Behavior_3" />Sloppy
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_4" name="cbBehavior_4" className='add-only' value="Behavior_4" />Slumped
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_5" name="cbBehavior_5" className='add-only' value="Behavior_5" />Cooperative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_6" name="cbBehavior_6" className='add-only' value="Behavior_6" />Open
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_7" name="cbBehavior_7" className='add-only' value="Behavior_7" />Irritable
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_8" name="cbBehavior_8" className='add-only' value="Behavior_8" />Anxious
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_9" name="cbBehavior_9" className='add-only' value="Behavior_9" />Calm
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_10" name="cbBehavior_10" className='add-only' value="Behavior_10" />Combative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_11" name="cbBehavior_11" className='add-only' value="Behavior_11" />Agitated
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_12" name="cbBehavior_12" className='add-only' value="Behavior_12" />Defensive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbBehavior_13" name="cbBehavior_13" className='add-only' value="Behavior_13" />Other :
                            <input type="text" id="txtBehavior_13" name="txtBehavior_13" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Mood/Affect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Mood_1" />Appropriate
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Mood_2" />Apathetic
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Mood_3" />Euphoric
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Mood_4" />Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Mood_5" />Flat
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Mood_6" />Hostile
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Mood_7" />Sad
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_8" name="cbMood_8" className='add-only' value="Mood_8" />Tearful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMood_9" name="cbMood_9" className='add-only' value="Mood_9" />Other :
                            <input type="text" id="txtMood_9" name="txtMood_9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Speech</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Speech_1" />Normal Limits
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Speech_2" />Rapid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Speech_3" />Stuttering
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Speech_4" />Slurred
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Speech_5" />Soft
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Speech_6" />Pressured
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Speech_7" />Others :
                            <input type="text" id="txtSpeech_7" name="txtSpeech_7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Thought Process</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="ThoughtProcess_1" />Logical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="ThoughtProcess_2" />Grandiose
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="ThoughtProcess_3" />Paranoid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="ThoughtProcess_4" />Unorganized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="ThoughtProcess_5" />Loose
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_6" name="cbThoughtProcess_6" className='add-only' value="ThoughtProcess_6" />Delusional
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_7" name="cbThoughtProcess_7" className='add-only' value="ThoughtProcess_7" />Tangential
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbThoughtProcess_8" name="cbThoughtProcess_8" className='add-only' value="ThoughtProcess_8" />Other :
                            <input type="text" id="txtThoughtProcess_8" name="txtThoughtProcess_8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Perception</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_1" name="cbPerception_1" className='add-only' value="Perception_1" />Normal Limits
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_2" name="cbPerception_2" className='add-only' value="Perception_2" />Auditory Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_3" name="cbPerception_3" className='add-only' value="Perception_3" />Visual Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_4" name="cbPerception_4" className='add-only' value="Perception_4" />Tactile Hallucinations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPerception_5" name="cbPerception_5" className='add-only' value="Perception_5" />Other :
                            <input type="text" id="txtPerception_5" name="txtPerception_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Orientation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Orientation_1" />To person
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Orientation_2" />To place
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Orientation_3" />To situation
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Orientation_4" />To time
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_5" name="cbOrientation_5" className='add-only' value="Orientation_5" />Disoriented
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Memory</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_1" name="cbMemory_1" className='add-only' value="Memory_1" />Recent intact (Can repeat 3 digits)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_2" name="cbMemory_2" className='add-only' value="Memory_2" />Remote intact (can provide history)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_3" name="cbMemory_3" className='add-only' value="Memory_3" />Recent not intact
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_4" name="cbMemory_4" className='add-only' value="Memory_4" />Remote not intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemory_5" name="cbMemory_5" className='add-only' value="Memory_5" />Other :
                            <input type="text" id="txtMemory_5" name="txtMemory_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Insight into illness/life situation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Insight_1" />Unimpaired
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Insight_2" />Limited
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Insight_3" />Absent
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbInsight_4" name="cbInsight_4" className='add-only' value="Insight_4" />Other :
                            <input type="text" id="txtInsight_4" name="txtInsight_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Suicidal Ideation:</span>
                    <input type="radio" id="rbSuicidalIdeation_Yes" name="rbSuicidalIdeation" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbSuicidalIdeation_No" name="rbSuicidalIdeation" className='add-only' value="No" /> No
                    <span className='eleHeader'>Homicidal :</span>
                    <input type="radio" id="rbHomicidalIdeations_Yes" name="rbHomicidalIdeations" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbHomicidalIdeations_No" name="rbHomicidalIdeations" className='add-only' value="No" /> No
                </p>
                <p>
                    <span className='eleHeader'>If risk exists, Individual is able to contract not to harm:</span>
                    <input type="radio" id="rbSuicidalIdeation1_Yes" name="rbSuicidalIdeation1" className='add-only' value="Yes" /> Self &nbsp;
                    <input type="radio" id="rbSuicidalIdeation1_No" name="rbSuicidalIdeation1" className='add-only' value="No" /> Others
                    <input type="text" id="txtServiceParticipantsOthers" name="txtServiceParticipantsOthers" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Mental Status:</span>
                    <span className='small'>(Describe Individual's mood, affect, thought processes, though contact, AVH, intelligence, insight, judgment, and orientation)</span>

                    Please indicate age, race, marital status here. Please describe the individual (short, tall, slim, obese, hair color, skin color, any unique characteristics (tattoos, burns, piercings etc) Make sure the description in this box matches the check marks above. Be sure to indicate the location of the assessment.

                    <textarea id="txtMentalStatus" name="txtMentalStatus" className='add-only'></textarea>
                </p>
                <p>
                    <strong>Telehealth Language:</strong>
                    Behavioral Health Assessment was held via telehealth and individual consented to the use of telehealth. Assessor assessed the individual's location and checked for safety. Individual was home at the time of the assessment. Assessment was held in compliance with DBHDD policies and procedures using a HIPAA/BAA-compliant telehealth platform.
                    <textarea id="txtTelehealthLanguage" name="txtTelehealthLanguage" className='add-only'></textarea>
                </p>
                <h3>D. PRESENTING PROBLEM AND REQUESTED SERVICE</h3>
                <p>
                    <span className='eleHeader'>What is the Individual's presenting problem / Diagnostic Criteria:</span>
                    <span className='small'>
                        Please place in quotes, using the client's words, the main reason the individual wants services. <br />
                        This section should be at least two paragraphs long. The first paragraph should provide information on the client's perspective of the problem and why they are seeking treatment <br />
                        In the second paragraph use clinical terms to explain why they are here... be sure to indicate the specific clinical symptoms (crying, isolation, hearing voices, etc). Then describe how long they have had them, how often they occur and if they are less or more frequent than in the past. If there are any significant events (suicide, homicide, probation, jail time, death in the family, etc) please be sure to obtain the date when those instances occurred.

                    </span>
                    <textarea id="txtIndividualPresentingProblem" name="txtIndividualPresentingProblem" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Origin of problem/when it began:</span>
                    <span className='small'>Include the onset of the problem, duration, frequency, past intervention/services and the results of the services.</span>
                    <textarea id="txtOriginProblem" name="txtOriginProblem" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Related Issues that exacerbate the problem:</span>
                    <span className='small'>Be sure to describe any events that make their symptoms or situation worse.</span>
                    <textarea id="txtRelatedIssues" name="txtRelatedIssues" className='add-only'></textarea>
                </p>
                <h3>E. MEDICAL HEALTH HISTORY/ASSESSMENT</h3>
                <p>
                    List all major illness, surgeries, major injuries. Begin with most recent and work backwards
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Past Conditions </span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Onset </span></td>
                        <td className='w-250'><span className='eleHeader'>Residual Effects </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_1" name="txtPast_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_1" name="txtDateOf_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_1" name="txtResidual_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_2" name="txtPast_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_2" name="txtDateOf_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_2" name="txtResidual_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    Ask for the name and contact information for their psychiatrist.
                </h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Psychiatrist:</span>
                            <input type="text" id="txtCurrentPsychiatrist" name="txtCurrentPsychiatrist" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone No.</span>
                            <input type="text" id="txtTelephone" name="txtTelephone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    Ask for the name and contact information for their primary care physician. If Individual does not have a doctor please type: "Individual reported not having PCP; will provide resources" Let the CM know when you submit your assessment
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Primary Care Physician:</span>
                            <input type="text" id="txtCurrentPrimary" name="txtCurrentPrimary" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone No.</span>
                            <input type="text" id="txtTelephone2" name="txtTelephone2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    Ask for the name and contact information for their pharmacy.
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Pharmacy:</span>
                            <input type="text" id="txtCurrentPharmacy" name="txtCurrentPharmacy" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone No.</span>
                            <input type="text" id="txtTelephone3" name="txtTelephone3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date of last PCP Visit:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of last Dental Visit: </span></td>
                        <td className='w-250'><span className='eleHeader'>Date of last Vision Exam:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtLastPcp" name="txtLastPcp" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtLastDental" name="txtLastDental" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtLastVision" name="txtLastVision" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    NUTRITIONAL/WELLNESS SCREENING
                </h3>
                <table>
                    <tr>
                        <td colspan="2"><strong>Nutritional Status</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Weight:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current Height:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" placeholder="Must Complete" id="txtCurrentWeight" name="txtCurrentWeight" className='add-only' required />
                        </td>
                        <td className='w-375'>
                            <input type="text" placeholder="Must Complete" id="txtCurrentHeight" name="txtCurrentHeight" className='add-only' required />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appetite</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_1" name="cbAppetite_1" className='add-only' value="Appetite_1" />Good
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_2" name="cbAppetite_2" className='add-only' value="Appetite_2" />Fair
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_3" name="cbAppetite_3" className='add-only' value="Appetite_3" />Poor,explain below
                            <input type="text" id="txtExplainBelowAppetite_3" name="txtExplainBelowAppetite_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eating Behavior</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEatingBehavior_1" name="cbEatingBehavior_1" className='add-only' value="EatingBehavior_1" />Binges/overeats to excess
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEatingBehavior_2" name="cbEatingBehavior_2" className='add-only' value="EatingBehavior_2" />Hiding/Hording food
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEatingBehavior_3" name="cbEatingBehavior_3" className='add-only' value="EatingBehavior_3" />Restricts food/vomits/over-exercises to avoid weight gain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_1" name="cbOther_1" className='add-only' value="Other_1" />Recently gained/lost significant weight
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_2" name="cbOther_2" className='add-only' value="Other_2" />Special Dietary Needs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_3" name="cbOther_3" className='add-only' value="Other_3" />Allergies, explain below
                            <input type="text" id="txtExplainBelowOther_3" name="txtExplainBelowOther_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Exercise Regularly</span>
                    <input type="radio" id="rbExercise_Yes" name="rbExercise" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbExercise_No" name="rbExercise" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>HIV Prevention Education information offered</span>
                    <input type="radio" id="rbHivPreventionAccepted_Yes" name="rbHivPreventionAcceptedDeclined" className='add-only' value="1" /> Accepted &nbsp;
                    <input type="radio" id="rbHivPreventionDeclined_No" name="rbHivPreventionAcceptedDeclined" className='add-only' value="0" /> Declined
                </p>
                <p>
                    <span className='eleHeader'>HIV Testing referral offered</span>
                    <input type="radio" id="rbHivTestingAccepted_Yes" name="rbHivTestingAcceptedDeclined" className='add-only' value="1" /> Accepted &nbsp;
                    <input type="radio" id="rbHivTestingDeclined_No" name="rbHivTestingAcceptedDeclined" className='add-only' value="0" /> Declined
                </p>
                <p>
                    <span className='eleHeader'>Comments</span>
                    <textarea id="txtHivComments" name="txtHivComments" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>ASSISTIVE TECHNOLOGY OR ADAPTIVE DEVICES</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_1" name="cbAssistiveTechnology_1" className='add-only' value="AssistiveTechnology_1" />None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_2" name="cbAssistiveTechnology_2" className='add-only' value="AssistiveTechnology_2" />Glasses
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_3" name="cbAssistiveTechnology_3" className='add-only' value="AssistiveTechnology_3" />Walker
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_4" name="cbAssistiveTechnology_4" className='add-only' value="AssistiveTechnology_4" />Braille
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_5" name="cbAssistiveTechnology_5" className='add-only' value="AssistiveTechnology_5" />Hearing Aids
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_6" name="cbAssistiveTechnology_6" className='add-only' value="AssistiveTechnology_6" />Cane
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_7" name="cbAssistiveTechnology_7" className='add-only' value="AssistiveTechnology_7" />Crutches
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_8" name="cbAssistiveTechnology_8" className='add-only' value="AssistiveTechnology_8" />Wheelchair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_9" name="cbAssistiveTechnology_9" className='add-only' value="AssistiveTechnology_9" />Translated Written Information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_10" name="cbAssistiveTechnology_10" className='add-only' value="AssistiveTechnology_10" />Translator for Speaking
                        </td>
                        <td colspan="2">
                            <input type="checkbox" id="cbAssistiveTechnology_11" name="cbAssistiveTechnology_11" className='add-only' value="AssistiveTechnology_11" />Other :
                            <input type="text" id="txtAssistiveTechnology_11" name="txtAssistiveTechnology_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If any of the above were checked, please provide details below.</span> <span className='small'>(list allergies)</span>
                    <textarea id="txtAssistiveTechnology" name="txtAssistiveTechnology" className='add-only'></textarea>
                </p>
                <h3>Health Issues/Medical History</h3>
                <p>
                    <span className='eleHeader'>Current Health Issues:</span>
                    <input type="checkbox" id="cbCurrent" name="cbCurrent" className='add-only' value="None" />None reported
                </p>
                <p>
                    Who is treating this medical issue:<input type="text" id="txtMedical" name="txtMedical" className='add-only' />
                </p>
                <p>
                    If none, make referral and coordinate services.
                </p>
                <p>
                    <span className='eleHeader'>Past Health Issues:</span>
                    <input type="checkbox" id="cbCurrent1" name="cbCurrent1" className='add-only' value="None1" />None reported
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hearing</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing1" name="cbHearing1" className='add-only' value="Hearing1" />
                            WNL
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing2" name="cbHearing2" className='add-only' value="Hearing2" />
                            Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing3" name="cbHearing3" className='add-only' value="Hearing3" />
                            Needs follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Vision</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing4" name="cbHearing4" className='add-only' value="Hearing4" />
                            WNL
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing5" name="cbHearing5" className='add-only' value="Hearing5" />
                            Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing6" name="cbHearing6" className='add-only' value="Hearing6" />
                            Needs follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing7" name="cbHearing7" className='add-only' value="Hearing7" />
                            Wears glasses
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech4" name="cbSpeech4" className='add-only' value="Speech4" />
                            WNL
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech5" name="cbSpeech5" className='add-only' value="Speech5" />
                            Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech6" name="cbSpeech6" className='add-only' value="Speech6" />
                            Needs follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Immunizations</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizations1" name="cbImmunizations1" className='add-only' value="Immunizations1" />
                            Up to date
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizations2" name="cbImmunizations2" className='add-only' value="Immunizations2" />
                            Needs follow-up
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Self-Identification of Infectious Diseases</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizations3" name="cbImmunizations3" className='add-only' value="Immunizations3" />
                            None reported
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Pregnant</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant_Yes" name="rbPregnant" className='add-only' value="1" /> Yes
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant_No" name="rbPregnant" className='add-only' value="0" /> No
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant_Np" name="rbPregnant" className='add-only' value="2" /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If Yes, Receiving Pre-Natal Care</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant1_Yes" name="rbPregnant1" className='add-only' value="1" /> Yes
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant1_No" name="rbPregnant1" className='add-only' value="0" /> No
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Current Medication </span><span className='small'>(prescription/OTC/Herbal)</span>
                    <input type="checkbox" id="cbReported" name="cbReported" className='add-only' value="Reported" />None Reported
                </p>
                <table>
                    <tr>
                        <td className='w-130'><span className='eleHeader'>Medication</span></td>
                        <td className='w-130'><span className='eleHeader'>Reason</span></td>
                        <td className='w-130'><span className='eleHeader'>Treatment Efficacy</span></td>
                        <td className='w-100'><span className='eleHeader'>Dosage/ Route/ Frequency</span></td>
                        <td className='w-260'><span className='eleHeader'>Compliance</span></td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedication1" name="txtMedication1" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtReason1" name="txtReason1" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtTreatmentEfficacy1" name="txtTreatmentEfficacy1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDosage1" name="txtDosage1" className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type="radio" id="rbCompliance1_Yes" name="rbCompliance1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbCompliance1_No" name="rbCompliance1" className='add-only' value="0" /> No  &nbsp;
                            <input type="radio" id="rbCompliance1_Ys" name="rbCompliance1" className='add-only' value="2" /> Partial  &nbsp;
                            <input type="radio" id="rbCompliance1_Np" name="rbCompliance1" className='add-only' value="3" /> Unk
                        </td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedication2" name="txtMedications2" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtReason2" name="txtReason2" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtTreatmentEfficacy2" name="txtTreatmentEfficacy2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDosage2" name="txtDosage2" className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type="radio" id="rbCompliance2_Yes" name="rbCompliance2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbCompliance2_No" name="rbCompliance2" className='add-only' value="0" /> No &nbsp;
                            <input type="radio" id="rbCompliance2_Ys" name="rbCompliance2" className='add-only' value="2" /> Partial &nbsp;
                            <input type="radio" id="rbCompliance2_Np" name="rbCompliance2" className='add-only' value="3" /> Unk
                        </td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedication3" name="txtMedication3" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtReason3" name="txtReason3" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtTreatmentEfficacy3" name="txtTreatmentEfficacy3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDosage3" name="txtDosage3" className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type="radio" id="rbCompliance3_Yes" name="rbCompliance3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbCompliance3_No" name="rbCompliance3" className='add-only' value="0" /> No &nbsp;
                            <input type="radio" id="rbCompliance3_Ys" name="rbCompliance3" className='add-only' value="2" /> Partial &nbsp;
                            <input type="radio" id="rbCompliance3_Np" name="rbCompliance3" className='add-only' value="3" /> Unk
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Please describe in detail any items that were checked above.</span>
                    <textarea id="txtAssistivA" name="txtAssistivA" className='add-only'></textarea>
                </p>
                <h3>FAMILY MEDICAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Type of Illness</span></td>
                        <td className='w-75'><span className='eleHeader'>Yes</span></td>
                        <td className='w-75'><span className='eleHeader'>No</span></td>
                        <td className='w-350'><span className='eleHeader'>Relationship (Father, Mother, Sibling, Aunt, Uncle, etc...)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cardiovascular</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_1" name="rbIllness_1" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_1" name="rbIllness_1" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_1" name="txtRelationship_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hypertension</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_2" name="rbIllness_2" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_2" name="rbIllness_2" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_2" name="txtRelationship_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Seizures</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_3" name="rbIllness_3" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_3" name="rbIllness_3" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_3" name="txtRelationship_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Psychiatric Hospitalization</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_4" name="rbIllness_4" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_4" name="rbIllness_4" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_4" name="txtRelationship_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Suicide</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_5" name="rbIllness_5" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_5" name="rbIllness_5" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_5" name="txtRelationship_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Depression</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_6" name="rbIllness_6" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_6" name="rbIllness_6" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_6" name="txtRelationship_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Addictions</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_7" name="rbIllness_7" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_7" name="rbIllness_7" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_7" name="txtRelationship_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Eating Disorder</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_8" name="rbIllness_8" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_8" name="rbIllness_8" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_8" name="txtRelationship_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cancer</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_9" name="rbIllness_9" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_9" name="rbIllness_9" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_9" name="txtRelationship_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Diabetes</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_11" name="rbIllness_11" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_11" name="rbIllness_11" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_11" name="txtRelationship_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other:</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_10" name="rbIllness_10" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_10" name="rbIllness_10" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_10" name="txtRelationship_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>F. BEHAVIOR AND MENTAL HEALTH ASSESSMENT</h3>
                <p>
                    Please complete the below checklist for symptoms:
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Key:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>Severity Rating:</strong></td>
                        <td className='w-375'><strong>Duration Rating:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>H=</strong></td>
                        <td className='w-325'>History Now Stable</td>
                        <td className='w-50'><strong>1=</strong></td>
                        <td className='w-325'>Less than 1 Month</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>1=</strong></td>
                        <td className='w-325'>Mild (infrequent)</td>
                        <td className='w-50'><strong>2=</strong></td>
                        <td className='w-325'>1 to 6 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>2=</strong></td>
                        <td className='w-325'>Moderate (frequent)</td>
                        <td className='w-50'><strong>3=</strong></td>
                        <td className='w-325'>7 to 11 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>3=</strong></td>
                        <td className='w-325'>Severe (acute crisis)</td>
                        <td className='w-50'><strong>4=</strong></td>
                        <td className='w-325'>More than 1 Year</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Symptom/Problem</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                        <td className='w-150'><span className='eleHeader'>Duration</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>1.	Anxiety</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_1" name="txtSeverity_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_1" name="txtDuration_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>2.	Appetite Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_2" name="txtSeverity_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_2" name="txtDuration_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>3.	Bizarre Behavior</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_3" name="txtSeverity_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_3" name="txtDuration_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>4.	Bizarre Ideations (Delusions)</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_4" name="txtSeverity_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_4" name="txtDuration_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>5.	Conduct Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_5" name="txtSeverity_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_5" name="txtDuration_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>6.	Depression</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_6" name="txtSeverity_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_6" name="txtDuration_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>7.	Eating Disorder</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_7" name="txtSeverity_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_7" name="txtDuration_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>8.	Family Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_8" name="txtSeverity_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_8" name="txtDuration_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>9.	Gender Issues</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_9" name="txtSeverity_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_9" name="txtDuration_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>10.	Impaired Memory</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_10" name="txtSeverity_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_10" name="txtDuration_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>11.	Indep. Living Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_11" name="txtSeverity_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_11" name="txtDuration_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>12.	Lack of Support System</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_12" name="txtSeverity_12" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_12" name="txtDuration_12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>13.	Loss of Energy</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_13" name="txtSeverity_13" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_13" name="txtDuration_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>14.	Loss of Interest</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_14" name="txtSeverity_14" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_14" name="txtDuration_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>15.	Obsessive/Compulsive</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_15" name="txtSeverity_15" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_15" name="txtDuration_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>16.	Panic Attacks</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_16" name="txtSeverity_16" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_16" name="txtDuration_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>17.	Paranoid Ideation</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_17" name="txtSeverity_17" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_17" name="txtDuration_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>18.	Phobia</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_18" name="txtSeverity_18" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_18" name="txtDuration_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>19.	Poor Interpersonal Skills</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_19" name="txtSeverity_19" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_19" name="txtDuration_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>20.	Poor Judgment</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_20" name="txtSeverity_20" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_20" name="txtDuration_20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>21. Poor Self Care Skills</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_21" name="txtSeverity_21" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_21" name="txtDuration_21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>22. School Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_22" name="txtSeverity_22" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_22" name="txtDuration_22" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>23. Sexual Acting Out</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_23" name="txtSeverity_23" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_23" name="txtDuration_23" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>24. Sleep Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_24" name="txtSeverity_24" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_24" name="txtDuration_24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>25. Somatization</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_25" name="txtSeverity_25" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_25" name="txtDuration_25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>26. Unusual Body Movements</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_26" name="txtSeverity_26" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_26" name="txtDuration_26" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>27. Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_27" name="txtSeverity_27" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_27" name="txtDuration_27" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If any of the above were checked (1-4), please provide specific details below. Please indicate frequency and intensity of symptoms.</span>
                    <span className='small'>
                        Please describe in detail any items that were checked above. <br />
                        Then describe how long they have had them (duration), how often they occur (frequency) and if they are less or more frequent then in the past (intensity). <br />
                        Each symptom listed in this section MUST be addressed in the treatment plan.

                    </span>
                    <textarea id="txtAssistiv" name="txtAssistiv" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Has Individual ever been treated for a mental health problem? </span><span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions, and outcome)</span>
                    <input type="radio" id="rbCrisisHas_Yes" name="rbCrisisHas" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCrisisHas_No" name="rbCrisisHas" className='add-only' value="0" /> No
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Date (s)</span></td>
                        <td className='w-150'><span className='eleHeader'>Location</span></td>
                        <td className='w-150'><span className='eleHeader'>Type of Treatment </span><span className='small'>(Outpatient, Inpatient, etc)</span></td>
                        <td className='w-150'><span className='eleHeader'>Diagnosis Given</span></td>
                        <td className='w-150'><span className='eleHeader'>Outcome </span><span className='small'>(i.e., stabilized, withdrew from services, etc.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_1" name="txtDate_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_1" name="txtLocation_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_1" name="txtTreatment_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_1" name="txtDiagnosis_" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_1" name="txtOutcome_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_2" name="txtDate_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_2" name="txtLocation_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_2" name="txtTreatment_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_2" name="txtDiagnosis_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_2" name="txtOutcome_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_3" name="txtDate_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_3" name="txtLocation_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_3" name="txtTreatment_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_3" name="txtDiagnosis_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_3" name="txtOutcome_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>G. SUBSTANCE ABUSE HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of 1<sup>st</sup> Use</span> <span className='small'> Must Complete  </span> </td>
                        <td className='w-150'><span className='eleHeader'>Age of Heaviest Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Alcohol</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_1" name="txtAgeFirstUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_1" name="txtAgeHeaviestUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_1" name="txtAmount_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_1" name="txtLastuse_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cannabis</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_2" name="txtAgeFirstUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_2" name="txtAgeHeaviestUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_2" name="txtAmount_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_2" name="txtLastuse_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cocaine</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_3" name="txtAgeFirstUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_3" name="txtAgeHeaviestUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_3" name="txtAmount_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_3" name="txtLastuse_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Stimulants
                            <span className='small'>(Crystal, speed, amphetamines)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_4" name="txtAgeFirstUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_4" name="txtAgeHeaviestUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_4" name="txtAmount_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_4" name="txtLastuse_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Methamphetamine</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_5" name="txtAgeFirstUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_5" name="txtAgeHeaviestUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_5" name="txtAmount_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_5" name="txtLastuse_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Inhalants
                            <span className='small'>(LSD, PCP, mushrooms)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_6" name="txtAgeFirstUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_6" name="txtAgeHeaviestUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_6" name="txtAmount_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_6" name="txtLastuse_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Opioids
                            <span className='small'>(Heroine, Narcotics, Methadone)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_7" name="txtAgeFirstUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_7" name="txtAgeHeaviestUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_7" name="txtAmount_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_7" name="txtLastuse_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Sedative/Hypnotics
                            <span className='small'>(Valium,  Xanax)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_8" name="txtAgeFirstUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_8" name="txtAgeHeaviestUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_8" name="txtAmount_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_8" name="txtLastuse_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Designer Drugs
                            <span className='small'>(Herbal, Steroids, Cough Syrup)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_9" name="txtAgeFirstUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_9" name="txtAgeHeaviestUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_9" name="txtAmount_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_9" name="txtLastuse_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Tobacco</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_10" name="txtAgeFirstUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_10" name="txtAgeHeaviestUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_10" name="txtAmount_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_10" name="txtLastuse_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_11" name="txtAgeFirstUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_11" name="txtAgeHeaviestUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_11" name="txtAmount_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_11" name="txtLastuse_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What consequences has the Individual faced as a result of the Drug/Alcohol use?</span>
                    <span className='small'>
                        (Include hangovers, DT's, Blackouts, Binges, Overdoses, Seizures, GI Bleeding, Job Loss, DUI's, Assaults, Incarcerations, Homicides, etc)
                        <br />
                        Be sure to ask about legal problems, family problems, school/work problems, mental health problems that have been impacted by their use of drugs.</span>
                    <textarea id="txtConsequences" name="txtConsequences" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Longest period of sobriety?</span></td>
                        <td className='w-375'><span className='eleHeader'>When?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLongestSobriety" name="txtLongestSobriety" className='add-only' required />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLongestSobrietyWhen" name="txtLongestSobrietyWhen" className='add-only' required />
                        </td>
                    </tr>
                </table>
                <h3>H. LEGAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_1" name="cbLegalHistory_1" className='add-only' value="LegalHistory_1" />
                            Probation Officer Contact and County:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_2" name="cbLegalHistory_2" className='add-only' value="LegalHistory_2" />
                            Parole  Officer Contact and County:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_1" name="txtLegalHistory_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_2" name="txtLegalHistory_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_3" name="cbLegalHistory_3" className='add-only' value="LegalHistory_3" />
                            Number of Arrest in Past 30 Days:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_4" name="cbLegalHistory_4" className='add-only' value="LegalHistory_4" />
                            Number of arrests in the past year:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_3" name="txtLegalHistory_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_4" name="txtLegalHistory_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_5" name="cbLegalHistory_5" className='add-only' value="LegalHistory_5" />
                            Current Pending Charges:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_6" name="cbLegalHistory_6" className='add-only' value="LegalHistory_6" />
                            DFCS/CPS and County
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_5" name="txtLegalHistory_5" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_6" name="txtLegalHistory_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_7" name="cbLegalHistory_7" className='add-only' value="LegalHistory_7" />
                            Restraining Order
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_8" name="cbLegalHistory_8" className='add-only' value="LegalHistory_8" />
                            None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_7" name="txtLegalHistory_7" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <h3>I. FAMILY HISTORY</h3>
                <p>
                    <strong>HOUSEHOLD COMPOSITION AT TIME OF ASSESSMENT</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'>Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Relationship to Individual</span></td>
                        <td className='w-200'><span className='eleHeader'>Date of Birth</span></td>
                        <td className='w-100'><span className='eleHeader'>Age</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_1" name="txtName_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_1" name="txtRelationshipIndividual_1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_1" name="txtDob_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_1" name="txtAge_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_2" name="txtName_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_2" name="txtRelationshipIndividual_2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_2" name="txtDob_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_2" name="txtAge_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_3" name="txtName_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_3" name="txtRelationshipIndividual_3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_3" name="txtDob_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_3" name="txtAge_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_4" name="txtName_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_4" name="txtRelationshipIndividual_4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_4" name="txtDob_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_4" name="txtAge_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    The following individuals are involved and invested in my treatment and recovery.
                </h4>
                <h4>
                    An ROI is required for these individuals:
                </h4>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Name:</span>
                            <input type="text" name="txtNameRoi1" id="txtNameRoi1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Relationship to Individual</span>
                            <input type="text" name="txtRelationshipIndividual1" id="txtRelationshipIndividual1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type="text" name="txtPhoneNumber1" id="txtPhoneNumber1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>ROI Complete?</span>
                            <input type="radio" id="rbComplete_Yes" name="rb_Complete" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbComplete_No" name="rb_Complete" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" name="txtNameRoi2" id="txtNameRoi2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtRelationshipIndividual2" id="txtRelationshipIndividual2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtPhoneNumber2" id="txtPhoneNumber2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbComplete2_Yes" name="rb_Complete2" className='add-only' value="1" /> Yes  &nbsp;
                            <input type="radio" id="rbComplete2_No" name="rb_Complete2" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" name="txtNameRoi3" id="txtNameRoi3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtRelationshipIndividual3" id="txtRelationshipIndividual3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtPhoneNumber3" id="txtPhoneNumber3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbComplete3_Yes" name="rb_Complete3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbComplete3_No" name="rb_Complete3" className='add-only' value="0" /> No
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>LIVING SITUATION </span>
                    <span className='small'>(Check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_1" name="cbLivingSituation_1" className='add-only' value="LivingSituation_1" />
                            Home w/ family of origin
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_2" name="cbLivingSituation_2" className='add-only' value="LivingSituation_2" />
                            Independent Living
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_3" name="cbLivingSituation_3" className='add-only' value="LivingSituation_3" />
                            Group Home/Foster Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_4" name="cbLivingSituation_4" className='add-only' value="LivingSituation_4" />
                            Homeless
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_5" name="cbLivingSituation_5" className='add-only' value="LivingSituation_5" />
                            Adequate Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_6" name="cbLivingSituation_6" className='add-only' value="LivingSituation_6" />
                            Safety Risks/Hazardous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_7" name="cbLivingSituation_7" className='add-only' value="LivingSituation_7" />
                            Overcrowded
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_8" name="cbLivingSituation_8" className='add-only' value="LivingSituation_8" />
                            Risk of Homelessness
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What is the family's source(s) of income? Is income monthly, bi-weekly? Is income sufficient for household expenses?</span>
                    <textarea id="txtFamilySourceIncome" name="txtFamilySourceIncome" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Duration at current residence: Indicate the current living environment (i.e. single family home, apartment, personal care home, group home, etc.) and how long they have lived at their current address.</span>
                    Must Complete. Find out the source of income and how much. Please indicate how long they have lived at their current address in this section as well.
                    <textarea id="txtDescribeIndividualRelationship"
                        name="txtDescribeIndividualRelationship" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe Individual's relationship with biological parents.</span>
                    <textarea id="txtDescribeIndividualRelation" name="txtDescribeIndividualRelation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe Individual's relationship with siblings. How does individual describe their self as a child growing up in their family? </span>
                    <textarea id="txtDescribeIndividualRelationshipSiblings" name="txtDescribeIndividualRelationshipSiblings" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Did you experience problems during your childhood?</span>
                    <span className='small'>(conflict with parents, siblings, teachers, overweight, etc...)</span>
                    <textarea id="txtExperienceProblems" name="txtExperienceProblems" className='add-only'></textarea>
                </p>
                <h3>MARITAL HISTORY</h3>
                <p>
                    <span className='eleHeader'>Marital Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_1" name="cbMaritalStatus_1" className='add-only' value="MaritalStatus_1" />Married
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_2" name="cbMaritalStatus_2" className='add-only' value="MaritalStatus_2" />Single
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_3" name="cbMaritalStatus_3" className='add-only' value="MaritalStatus_3" />Co-Habitation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_4" name="cbMaritalStatus_4" className='add-only' value="MaritalStatus_4" />Divorced
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_5" name="cbMaritalStatus_5" className='add-only' value="MaritalStatus_5" />Separated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_6" name="cbMaritalStatus_6" className='add-only' value="MaritalStatus_6" />Widowed
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Number of Marriages:</span></td>
                        <td className='w-375'><span className='eleHeader'>Length of Time with current partner:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtNumberPreviousMarriages" name="txtNumberPreviousMarriages" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLengthTimeCurrentPartner" name="txtLengthTimeCurrentPartner" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>How would you describe your relationship with your current partner?</span>
                    <textarea id="txtDescribeRelationship" name="txtDescribeRelationship" className='add-only'></textarea>
                </p>
                <h3>
                    TRAUMA & ABUSE HISTORY
                </h3>
                <p>
                    <span className='eleHeader'>Physical Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_1" name="cbPhysicalAbuse_1" className='add-only' value="PhysicalAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_2" name="cbPhysicalAbuse_2" className='add-only' value="PhysicalAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_3" name="cbPhysicalAbuse_3" className='add-only' value="PhysicalAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_4" name="cbPhysicalAbuse_4" className='add-only' value="PhysicalAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_5" name="cbPhysicalAbuse_5" className='add-only' value="PhysicalAbuse_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Domestic Violence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_1" name="cbDomesticViolence_1" className='add-only' value="DomesticViolence_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_2" name="cbDomesticViolence_2" className='add-only' value="DomesticViolence_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_3" name="cbDomesticViolence_3" className='add-only' value="DomesticViolence_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_4" name="cbDomesticViolence_4" className='add-only' value="DomesticViolence_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_5" name="cbDomesticViolence_5" className='add-only' value="DomesticViolence_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Community Violence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_1" name="cbCommunityViolence_1" className='add-only' value="CommunityViolence_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_2" name="cbCommunityViolence_2" className='add-only' value="CommunityViolence_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_3" name="cbCommunityViolence_3" className='add-only' value="CommunityViolence_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_4" name="cbCommunityViolence_4" className='add-only' value="CommunityViolence_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_5" name="cbCommunityViolence_5" className='add-only' value="CommunityViolence_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Physical Neglect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_1" name="cbPhysicalNeglect_1" className='add-only' value="PhysicalNeglect_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_2" name="cbPhysicalNeglect_2" className='add-only' value="PhysicalNeglect_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_3" name="cbPhysicalNeglect_3" className='add-only' value="PhysicalNeglect_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_4" name="cbPhysicalNeglect_4" className='add-only' value="PhysicalNeglect_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_5" name="cbPhysicalNeglect_5" className='add-only' value="PhysicalNeglect_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Emotional Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_1" name="cbEmotionalAbuse_1" className='add-only' value="EmotionalAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_2" name="cbEmotionalAbuse_2" className='add-only' value="EmotionalAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_3" name="cbEmotionalAbuse_3" className='add-only' value="EmotionalAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_4" name="cbEmotionalAbuse_4" className='add-only' value="EmotionalAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_5" name="cbEmotionalAbuse_5" className='add-only' value="EmotionalAbuse_5" />Current
                        </td>

                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Elder Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_1" name="cbElderAbuse_1" className='add-only' value="ElderAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_2" name="cbElderAbuse_2" className='add-only' value="ElderAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_3" name="cbElderAbuse_3" className='add-only' value="ElderAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_4" name="cbElderAbuse_4" className='add-only' value="ElderAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_5" name="cbElderAbuse_5" className='add-only' value="ElderAbuse_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Sexual Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_1" name="cbSexualAbuse_1" className='add-only' value="SexualAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_2" name="cbSexualAbuse_2" className='add-only' value="SexualAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_3" name="cbSexualAbuse_3" className='add-only' value="SexualAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_4" name="cbSexualAbuse_4" className='add-only' value="SexualAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_5" name="cbSexualAbuse_5" className='add-only' value="SexualAbuse_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>No Abuse History</span>
                    <input type="checkbox" id="cbNoAbuseHistory" name="cbNoAbuseHistory" className='add-only' value="NoAbuseHistory" />
                </p>
                <p>
                    <span className='eleHeader'>Is there a history of violence in past or current relationships? </span>
                    <span className='small'>Please provide details of Abuse History (if applicable):</span>
                    <textarea id="txtHistoryViolence" name="txtHistoryViolence" placeholder="Must Complete OR indicate no abuse history reported." className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>How would you describe your sexual preference/Orientation/gender expression?  </span>
                    <span className='small'>(Heterosexual, Homosexual, Bi-Sexual, Gender Identity, masculine, feminine, etc)</span>
                    <textarea id="txtHistoryViolence1" name="txtHistoryViolence1" className='add-only'></textarea>
                </p>
                <h3>J. EDUCATION ASSESSMENT</h3>
                <h4>
                    Highest Grade Completed:
                </h4>
                <p>
                    <span className='eleHeader'>H.S. Diploma</span>
                    <input type="radio" id="rbHighestEducation1_Yes" name="rbHighestEducation1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHighestEducation1_No" name="rbHighestEducation1" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>If no, GED</span>
                    <input type="radio" id="rbHighestEducation2_Yes" name="rbHighestEducation2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHighestEducation2_No" name="rbHighestEducation2" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Yrs. of Vocational School/College:</span>
                    <input type="checkbox" id="cbVocational" name="cbVocational" className='add-only' value="Vocational" /> N/A
                </p>
                <p>
                    <span className='eleHeader'>History of Special Education?:</span>
                    <input type="radio" id="rbHighestEducation3_Yes" name="rbHighestEducation3" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHighestEducation3_No" name="rbHighestEducation3" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Intellectual Disability?:</span>
                    <input type="radio" id="rbHighestEducation4_Yes" name="rbHighestEducation4" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHighestEducation4_No" name="rbHighestEducation4" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Literacy Level:</span>
                    <input type="radio" id="rbHighestEducation5_Yes" name="rbHighestEducation5" className='add-only' value="1" /> Appropriate for Age &nbsp;
                    <input type="radio" id="rbHighestEducation5_No" name="rbHighestEducation5" className='add-only' value="0" /> Defaulting Reading or Writing- Explain:
                    <textarea id="txtDefaulting" name="txtDefaulting" className='add-only'></textarea>
                </p>
                <h3>K. OCCUPATION</h3>
                <p>
                    <span className='eleHeader'>Is Individual currently employed?</span>
                    <input type="radio" id="rbEmployed_Yes" name="rbEmployed" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbEmployed_No" name="rbEmployed" className='add-only' value="0" /> No
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Employment:</span></td>
                        <td className='w-375'><span className='eleHeader'>Time at current place of employment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentEmployment" name="txtCurrentEmployment" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="time" id="txtHowLong" name="txtHowLong" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Disabled:</span>
                    <input type="radio" id="rbEmployed1_Yes" name="rbEmployed1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbEmployed1_No" name="rbEmployed1" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Have you experienced problems finding employment?
                    </span> <span className='small'>(please explain):
                    </span>
                    <textarea id="txtHaveExperiencedProblems" name="txtHaveExperiencedProblems" className='add-only'></textarea>
                </p>
                <h3>L. MILITARY HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Have you ever served?</span></td>
                        <td className='w-375'><span className='eleHeader'>If yes what branch?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbEmployed2_Yes" name="rbEmployed2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbEmployed2_No" name="rbEmployed2" className='add-only' value="0" /> No
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtBranch" name="txtBranch" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Years in service</span></td>
                        <td className='w-375'><span className='eleHeader'>Discharge Type</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtServiceYears" name="txtServiceYears" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtDischargeType" name="txtDischargeType" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Were you in combat </span>
                    <span className='small'>(do you experience any flashbacks, uncontrolled anger outbursts, etc...) </span>
                    <textarea id="txtCombat" name="txtCombat" className='add-only'></textarea>
                </p>
                <h3>M. ETHNIC/CULTURAL ORIENTATION  <span className='small'>(Check all that apply)</span></h3>
                <p>
                    <span className='eleHeader'>What type of community were you raised in:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised1" name="cbRaised1" className='add-only' value="Raised1" />Large City
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised2" name="cbRaised2" className='add-only' value="Raised2" />Medium Size city
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised3" name="cbRaised3" className='add-only' value="Raised3" />Large Town
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised4" name="cbRaised4" className='add-only' value="Raised4" />Small Town
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised5" name="cbRaised5" className='add-only' value="Raised5" />Rural
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What cultural practices linked to your racial/ethnic background are important to you, as it relates to your treatment?</span>
                    <textarea id="txtCulturalPractices" name="txtCulturalPractices" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are your hobbies or leisure preferences:</span>
                    <textarea id="txtHobbies" name="txtHobbies" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are your spiritual preferences:</span>
                    <textarea id="txtSpiritualPreferences" name="txtSpiritualPreferences" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What community involvement do you engage in:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage1" name="cbEngage1" className='add-only' value="Engage1" />
                            Volunteer
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage2" name="cbEngage2" className='add-only' value="Engage2" />
                            Employment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage3" name="cbEngage3" className='add-only' value="Engage3" />
                            Church
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage4" name="cbEngage4" className='add-only' value="Engage4" />
                            Family Activities
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage5" name="cbEngage5" className='add-only' value="Engage5" />
                            Vote
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage6" name="cbEngage6" className='add-only' value="Engage6" />
                            None
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Would you like to be more involved in the community:</span>
                    <input type="radio" id="rbCoOccurring6_Yes" name="rbCoOccurring6" className='add-only' value="1" /> Y &nbsp;
                    <input type="radio" id="rbCoOccurring6_No" name="rbCoOccurring6" className='add-only' value="0" /> N
                </p>
                <p>
                    If yes, what would you like to do:
                    <textarea id="txtSpiritualPreferences66" name="txtSpiritualPreferences66" className='add-only'></textarea>
                </p>
                <h3>N. SOCIAL SERVICES/SUPPORT NEEDS </h3>
                <span className='small'>(Check all that apply)</span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_1" name="cbSocialServices_1" className='add-only' value="SocialServices_1" />Income maintenance
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_2" name="cbSocialServices_2" className='add-only' value="SocialServices_2" />Food
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_3" name="cbSocialServices_3" className='add-only' value="SocialServices_3" />Clothing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_4" name="cbSocialServices_4" className='add-only' value="SocialServices_4" />Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_5" name="cbSocialServices_5" className='add-only' value="SocialServices_5" />Medical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_6" name="cbSocialServices_6" className='add-only' value="SocialServices_6" />Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_7" name="cbSocialServices_7" className='add-only' value="SocialServices_7" />Vocational
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_8" name="cbSocialServices_8" className='add-only' value="SocialServices_8" />Leisure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_9" name="cbSocialServices_9" className='add-only' value="SocialServices_9" />Social
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_10" name="cbSocialServices_10" className='add-only' value="SocialServices_10" />Whole Health/Wellness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_11" name="cbSocialServices_11" className='add-only' value="SocialServices_11" />Other:
                            <input type="text" id="txtSocialServices_Other" name="txtSocialServices_Other" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>O. FACTORS THAT MAY AFFECT LEARNING/TREATMENT</h3>
                <span className='small'>(Check all that apply)</span>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intellectual Functioning </span> <span className='small'>(Estimate)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectual1" name="cbIntellectual1" className='add-only' value="Intellectual1" />Above Avg.
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectual2" name="cbIntellectual2" className='add-only' value="Intellectual2" />Normal/Avg.
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectual3" name="cbIntellectual3" className='add-only' value="Intellectual3" />Borderline
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intellectual Disabilities:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbIntellectual4" name="cbIntellectual4" className='add-only' value="Intellectual4" />Mild
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbIntellectual5" name="cbIntellectual5" className='add-only' value="Intellectual5" />Moderate
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbIntellectual6" name="cbIntellectual6" className='add-only' value="Intellectual6" />Severe
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbIntellectual7" name="cbIntellectual7" className='add-only' value="Intellectual7" />NA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectual8" name="cbIntellectual8" className='add-only' value="Intellectual8" />Other/Describe:
                            <input type="text" id="txtSocialServices_Other14" name="txtSocialServices_Other14" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_1" name="cbFactorsLearning_1" className='add-only' value="FactorsLearning_1" />None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_2" name="cbFactorsLearning_2" className='add-only' value="FactorsLearning_2" />Cognitive Impairment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_3" name="cbFactorsLearning_3" className='add-only' value="FactorsLearning_3" />Lack of Motivation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_4" name="cbFactorsLearning_4" className='add-only' value="FactorsLearning_4" />Abuse/Neglect
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_5" name="cbFactorsLearning_5" className='add-only' value="FactorsLearning_5" />Pain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_6" name="cbFactorsLearning_6" className='add-only' value="FactorsLearning_6" />Language Barrier
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_7" name="cbFactorsLearning_7" className='add-only' value="FactorsLearning_7" />Impaired ability of read/write
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_8" name="cbFactorsLearning_8" className='add-only' value="FactorsLearning_8" />Sensory Impairment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_9" name="cbFactorsLearning_9" className='add-only' value="FactorsLearning_9" />Fatigue
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_10" name="cbFactorsLearning_10" className='add-only' value="FactorsLearning_10" />Physical Disability
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_11" name="cbFactorsLearning_11" className='add-only' value="FactorsLearning_11" />Acute/Chronic Organicity
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_12" name="cbFactorsLearning_12" className='add-only' value="FactorsLearning_12" />Substance Abuse
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <input type="checkbox" id="cbFactorsLearning_13" name="cbFactorsLearning_13" className='add-only' value="FactorsLearning_13" />Other
                            <input type="text" id="txtFactorsLearning_12" name="txtFactorsLearning_12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>P. SNAP: STRENGTHS, NEEDS, ABILITIES, PREFERENCES</h3>
                <p>
                    <span className='eleHeader'>What strengths does the Individual have that affects their quality of life?</span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    Please provide a quote in each box of the individuals answer and then add your clinical assessment for all items in sections P and Q.
                    <textarea id="txtWhatStrengths" name="txtWhatStrengths" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What is needed to increase the Individual's quality of life?</span>
                    <span className='small'>(Name specific interventions, resources for biological, psychological, and social/environmental barriers)</span>
                    <textarea id="txtIndividualQualityLife" name="txtIndividualQualityLife" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's abilities and skills that would help increase his/her quality of life?</span>
                    <span className='small'>(This should include personality traits, work skills, academic skills)</span>
                    <textarea id="txtIndividualAbilities" name="txtIndividualAbilities" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual and family's expectation of and preferences for this service?</span>
                    <span className='small'>(This should include the Individual's own words of his/her expected outcome)</span>
                    <textarea id="txtFamilyStrengths" name="txtFamilyStrengths" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's personal life goals regarding their treatment?</span>
                    <span className='small'>(This should include the Individual's own words)</span>
                    <textarea id="txtIndividualExpectation" name="txtIndividualExpectation" className='add-only'></textarea>
                </p>
                <h3>Q. Hopes / Choices / Preferences / Desired Outcomes</h3>
                <p>
                    <span className='eleHeader'>What Hopes does the Individual have regarding their treatment?</span>
                    <span className='small'>(This should include family, friend, teacher  supports, hobbies, community resources, education)</span>
                    <textarea id="txtWhatHopes" name="txtWhatHopes" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Choices does the Individual have regarding meeting his/her needs?</span>
                    <span className='small'>(Name specific resources, community opportunities, etc.)</span>
                    <textarea id="txtWhatChoices" name="txtWhatChoices" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Preferences does the Individual have regarding his/her treatment?</span>
                    <span className='small'>(This should be male/female community staff, meeting location and/or time, staff with specific specialty, etc.)</span>
                    <textarea id="txtWhatPreferences" name="txtWhatPreferences" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's Desired Outcomes for treatment?</span>
                    <span className='small'>(What does the Individual expect to achieve throughout his/her treatment?)</span>
                    <textarea id="txtWhatDesired" name="txtWhatDesired" className='add-only'></textarea>
                </p>
                <h3>R. Stage of Change: Indicate the current stage of change the individual is in for each of their issues and provide supporting evidence of your assessment.</h3>
                <p>
                    Remember the individual can be at different stages of change for each of their issues. Be sure to note that... for instance.... they are in the preparation stage when it comes to depression but in pre-contemplation or relapse when it comes to their drug use.
                </p>
                <p>
                    <strong>What Stage of Change is the Individual In:</strong>
                </p>
                <p>
                    <span className='eleHeader'>1.	Pre-Contemplation </span>
                    <span className='small'>(No intentions of changing)</span>
                    <textarea id="txtPreContemplation" name="txtPreContemplation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>2.	Contemplation </span>
                    <span className='small'>(Recognizing there's a problem with no commitment to change)</span>
                    <textarea id="txtContemplation" name="txtContemplation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>3.	Preparation </span>
                    <span className='small'>(Intent upon taking action soon and often report some steps in that direction)</span>
                    <textarea id="txtPreparation" name="txtPreparation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>4.	Action </span>
                    <span className='small'>(Is aware a problem exists and actively modifies their behavior, experiences and environment in order to overcome the problem. Commitment is clear and a great deal of effort is expended towards making changes)</span>
                    <textarea id="txtAction" name="txtAction" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>5.	Maintenance
                    </span>
                    <span className='small'>(Has made a sustained change wherein a new pattern of behavior has replaced the old. Behavior is firmly established and threat of relapse becomes less intense)</span>
                    <textarea id="txtMaintenance" name="txtMaintenance" className='add-only'></textarea>
                </p>
                <p>
                    <strong>***(Relapse)</strong>
                </p>
                <h3>S. DSM-5/ ICD-10 DIAGNOSTIC IMPRESSION:</h3>
                <p>
                    <strong>Place the DSM V and ICD 10 codes as well as spell out the diagnoses in this box.</strong>
                </p>
                <p>
                    <span className='eleHeader'>Co-Occurring Disorder</span>
                    <span className='small'>(More than one diagnosis of any kind warrants a co-occurring disorder, not just substance abuse)
                    </span>
                    <input type="radio" id="rbCoOccurring_Yes" name="rbCoOccurring" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCoOccurring_No" name="rbCoOccurring" className='add-only' value="0" /> No
                </p>
                <p>
                    <textarea id="txtDsmIcdDiagnosticImpression" name="txtDsmIcdDiagnosticImpression" className='add-only'></textarea>
                </p>
                <h3>T. INTERPRETIVE SUMMARY</h3>
                <p>
                    <span className='eleHeader'>Summary should begin with a brief description of the individual. Provide a summary that integrates all sections of the assessment (1-2 lines summarizing the presenting problem. Provide history of treatment and progress or lack thereof along with confirmed diagnosis and psychotropic medication. Provide information on medical history and medication prescribed. Information on legal and substance use history, etc.) Indicate individual's acceptance or understanding of his/her problems. Provide an explanation of goals the individual wants to work on and if individual refuses to address specific goals/challenges provide explanation here. Indicate the services recommended and how they will assist the individual with addressing their needs. Discuss the individual's strengths and limitations and how they will affect treatment.</span>
                    <span className='small'>Make sure this is a narrative explaining the full picture of the individual here, do not copy and paste items from above... make sure this helps all outside readers understand why you recommend or do not recommend services for this individual.
                    </span>
                    <textarea id="txtInterpretiveSummaryA" name="txtInterpretiveSummaryA" className='add-only'></textarea>
                </p>
                <h3>
                    U. Progress Made from Previous Treatment
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please indicate the level in which the Individual has made progress within their treatment.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbProgress_Yes" name="rbProgress" className='add-only' value="1" /> N/A - This is a New Intake. Progress will be monitored throughout treatment.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbProgress_Ys" name="rbProgress" className='add-only' value="2" /> Minimal Progress Made
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbProgress_Ye" name="rbProgress" className='add-only' value="3" /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbProgress_Yep" name="rbProgress" className='add-only' value="4" /> Goal Fully Achieved
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What's the evidence in which progress has / has not been made?</span>
                    <textarea id="txtImpression1" name="txtImpression1" className='add-only'></textarea>
                </p>
                <p>
                    <strong> Example:</strong> Individual has made moderate progress with goal 3; as evidenced by increasing her conflict resolution skills with her siblings to 0-1 fight per month; versus previously reports of 2-3 fights per month.
                </p>
                <h4>
                    V. RECOMMENDED SERVICES
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='small'>(select all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type="checkbox" id="cbServices_1" name="cbServices_1" className='add-only' value="Services_1" /> </td>
                        <td className='w-700'> Individual Counseling/Therapy (90832, 90834, 90837)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_2" name="cbServices_2" className='add-only' value="Services_2" />
                        </td>
                        <td className='w-700'> Family Counseling/Therapy (90846, 90847, H0004)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_3" name="cbServices_3" className='add-only' value="Services_3" />
                        </td>
                        <td className='w-700'> Psychosocial Rehabilitation-Individual (H2017)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_4" name="cbServices_4" className='add-only' value="Services_4" />
                        </td>
                        <td className='w-700'> Family Skills Training (H2014)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_5" name="cbServices_5" className='add-only' value="Services_5" />
                        </td>
                        <td className='w-700'> Addictive Disease Support Services (H2015HF) Adult Medicaid Only - Requested only if SA dx is present</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_6" name="cbServices_6" className='add-only' value="Services_6" />
                        </td>
                        <td className='w-700'> Case Management (T1016) </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_7" name="cbServices_7" className='add-only' value="Services_7" />
                        </td>
                        <td className='w-700'> Peer Support Services (H0038, H0038HQ)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_8" name="cbServices_8" className='add-only' value="Services_8" />
                        </td>
                        <td className='w-700'> Group Therapy (H0004HQ) Adult Medicaid Only</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_9" name="cbServices_9" className='add-only' value="Services_9" />
                        </td>
                        <td className='w-700'> Medication Management - Psychiatrist </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_91" name="cbServices_91" className='add-only' value="Services_91" />
                        </td>
                        <td className='w-700'> Medication Administration - Nurse Injections </td>
                    </tr>
                </table>
                <h3>COMPLETED BY:</h3>
                <p>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Assessor Signature:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Assessor Print Name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table>
                <h3>REVIEWED BY </h3>
                <span className='small'>(If Applicable):</span>
                <p>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Licensed Professional Signature:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Licensed Professional Print Name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table>






            </div>
        </form >

    )
}